export function parseRgbBackground(value) {
  if (!value) return '#ffffff';
  if (value.startsWith('#') || value.startsWith('rgb')) return value;
  const parts = String(value).split(',').map((n) => Number(n.trim()));
  if (parts.length >= 3) {
    const alpha = parts[3] != null ? parts[3] : 1;
    return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${alpha})`;
  }
  return '#ffffff';
}

export function layoutBoxToStyle(box) {
  return {
    position: 'absolute',
    left: `${(box.left || 0) * 100}%`,
    top: `${(box.top || 0) * 100}%`,
    width: `${(box.width || 0) * 100}%`,
    height: `${(box.height || 0) * 100}%`,
    zIndex: box.zorder ?? 1,
  };
}

/**
 * Optional: extract text from legacy Fabric layout JSON when content block is missing.
 */
export function parseLayoutTexts(layoutString) {
  if (!layoutString) {
    return { banners: [], editable: { title: 'Text Message', body: '' } };
  }

  try {
    const layout = typeof layoutString === 'string' ? JSON.parse(layoutString) : layoutString;
    const banners = [];
    let editable = { title: 'Text Message', body: '' };

    for (const obj of layout.objects || []) {
      if (obj.type !== 'group' || !Array.isArray(obj.objects)) continue;

      const texts = obj.objects
        .filter((child) => child.type === 'text' && child.text)
        .map((child) => child.text);

      if (obj.name === 'editable' || texts[0] === 'Text Message') {
        editable = { title: texts[0] || 'Text Message', body: texts[1] || '' };
      } else if (texts.length >= 2) {
        const key = `${texts[0]}|${texts[1]}`;
        if (!banners.some((b) => `${b.title}|${b.subtitle}` === key)) {
          banners.push({ title: texts[0], subtitle: texts[1] });
        }
      }
    }

    return { banners, editable };
  } catch {
    return { banners: [], editable: { title: 'Text Message', body: '' } };
  }
}

export function resolveTemplateContent(template) {
  const fromContent = template.content || {};
  const fromLayout = parseLayoutTexts(template.layout);
  const banner = fromLayout.banners[0] || {};

  return {
    bannerTitle: fromContent.bannerTitle || banner.title || template.name || '',
    bannerSubtitle: fromContent.bannerSubtitle || banner.subtitle || '',
    messageTitle: fromContent.messageTitle || fromLayout.editable.title || 'Text Message',
    messageBody: fromContent.messageBody || fromLayout.editable.body || '',
    bannerFill: fromContent.bannerFill || 'rgba(10, 79, 120, 1)',
  };
}
